import { render, staticRenderFns } from "./screen_tipo_reportes.vue?vue&type=template&id=2475f236"
import script from "./screen_tipo_reportes.vue?vue&type=script&lang=js"
export * from "./screen_tipo_reportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports